export const BorderColors = {
    borderColors: {
      borderPrimary100: "#000000",
      borderPrimary200: "#1A1A1A",
      borderPrimary300: "#333333",
      borderPrimary400: "#4D4D4D",
      borderPrimary500: "#666666",
      borderPrimary700: "#808080",
      borderPrimary800: "#999999",
      borderPrimary1000: "#B3B3B3",
      borderGold: "#4D4D4D",
    },
  };